export default __webpack_public_path__ + "static/media/Blood_droplet.3754aa27.svg";